import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';

const getSkin = (theme) => {
	const skin = theme.globalProfiles.palette;
	const myTypography = typography(theme);

	return StyleSheet.create({
		leaderBoardContainer: {
			background: '#EE774833',
			border: '1px solid #EE7748'
		},
		leaderboardText: {
			color: skin.white,
			...myTypography.body1,
			fontWeight: 600,
			fontSize: '0.75em'
		},
	});
}

export default getSkin;